import { render, staticRenderFns } from "./which-element.vue?vue&type=template&id=d700a94c&"
import script from "./which-element.vue?vue&type=script&lang=js&"
export * from "./which-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports